import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchDataMainVPO, getActionsOnlyVPO } from "../../api/api";
import { fetchDataMainSuccessVPO, fetchDataMainRequestVPO, createAnswerSuccessVPO, updateAnswerSuccessVPO, createQuestionnaireSuccessVPO, updateQuestionnaireSuccessVPO, fetchActionsOnlyRequestVPO, fetchActionsOnlySuccessVPO, toggleAuditRequestVPO, toggleAuditSuccessVPO, createOrUpdateAuditRequestVPO, createOrUpdateAuditSuccessVPO } from "./data-main";
import { BACKEND_URL, STRAPI_TOKEN } from "../../api/api";

export function* handleFetchDataMainVPO(action: ReturnType<typeof fetchDataMainRequestVPO>): SagaIterator {
  const params = action.payload;
  const data = yield call(fetchDataMainVPO, params);
  yield put(fetchDataMainSuccessVPO({ data, params }));
}

export function* handleCreateAnswerVPO(action) {
  try {
    const response = yield fetch(`${BACKEND_URL}/api/vpo-answers`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: action.payload }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при создании ответа');
    }

    const created = yield response.json();

    const getResponse = yield fetch(`${BACKEND_URL}/api/vpo-answers?filters[id][$eq]=${created.data.id}&populate=*`, {
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include'
  });
    const fullData = yield getResponse.json();
    console.log('fullData', fullData);

    yield put(createAnswerSuccessVPO(fullData));
  } catch (error) {

  }
}

export function* handleUpdateAnswerVPO(action) {
  try {
    const { id, Condition } = action.payload;

    const response = yield fetch(`${BACKEND_URL}/api/vpo-answers/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: { Condition: Condition } }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при обновлении ответа');
    }

    const result = yield response.json();

    console.log('result', result)

    yield put(updateAnswerSuccessVPO(result));
  } catch (error) {

  }
}

export function* handleCreateQuestionnaireVPO(action) {
  try {
    const response = yield fetch(`${BACKEND_URL}/api/vpo-status-questionnaires`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: action.payload }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при создании опросника');
    }

    const result = yield response.json();

    yield put(createQuestionnaireSuccessVPO(result));
  } catch (error) {
  }
}

export function* handleUpdateQuestionnaireVPO(action) {
  try {
    const { id, statusQuestionnaire, completionDate, nameCompleted, AuthorEnd, IsError } = action.payload;

    const response = yield fetch(`${BACKEND_URL}/api/vpo-status-questionnaires/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: { statusQuestionnaire, completionDate, nameCompleted, AuthorEnd, IsError } }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при обновлении опросника');
    }

    const result = yield response.json();

    console.log('result', result)

    yield put(updateQuestionnaireSuccessVPO(result));
  } catch (error) {

  }
}






//! для смены иконки
export function* fetchActionsOnlySagaVPO(action: ReturnType<typeof fetchActionsOnlyRequestVPO>): SagaIterator {
  try {
    const response: { actions: any[] } = yield call(getActionsOnlyVPO, action.payload);
    yield put(fetchActionsOnlySuccessVPO(response));
  } catch (error) {
    console.error('Ошибка загрузки действий:', error);
    yield put(fetchActionsOnlySuccessVPO({ actions: [] }));
  }
}

//! для переключения isAudit
export function* handleToggleAuditVPO(action: ReturnType<typeof toggleAuditRequestVPO>) {
  try {
    const { answerId, isAudit } = action.payload;

    const response = yield fetch(`${BACKEND_URL}/api/vpo-answers/${answerId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: { isAudit: isAudit } }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при обновлении isAudit');
    }

    yield put(toggleAuditSuccessVPO({ answerId, isAudit }));
  } catch (error) {
    console.error('Ошибка при обновлении isAudit:', error);
  }
}

//! Создание/обновление ответа с isAudit
export function* handleCreateOrUpdateAuditVPO(action: ReturnType<typeof createOrUpdateAuditRequestVPO>) {
  try {
    const response = yield fetch(`${BACKEND_URL}/api/vpo-check-answer-audit/create-or-update`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: action.payload }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при создании/обновлении ответа с isAudit');
    }

    const result = yield response.json();
    // console.log('result', result);

    yield put(createOrUpdateAuditSuccessVPO(result));
  } catch (error) {
    console.error('Ошибка isAudit:', error);
  }
}
